import { createContext, useContext, ReactNode, useCallback } from 'react';

import { useSseConnection, SmsCodeData, ConnectionState } from '../hooks/useSseConnection';

interface SseContextValue {
  connectionState: ConnectionState;
  receivedCodes: Map<string, SmsCodeData>;
  connect: () => void;
  disconnect: () => void;
  getCodeForNumber: (temporaryNumberId: string) => SmsCodeData | undefined;
  isConnected: boolean;
  isConnecting: boolean;
}

const SseContext = createContext<SseContextValue | undefined>(undefined);

interface SseContextProviderProps {
  children: ReactNode;
  autoConnect?: boolean;
}

export function SseContextProvider({ children, autoConnect = true }: SseContextProviderProps) {
  const onCodeReceived = useCallback((data: SmsCodeData) => {
    console.log('SSE: Code received', data);
  }, []);

  const sseConnection = useSseConnection({
    autoConnect,
    onCodeReceived,
  });

  return <SseContext.Provider value={sseConnection}>{children}</SseContext.Provider>;
}

export function useSse(): SseContextValue {
  const context = useContext(SseContext);
  if (context === undefined) {
    throw new Error('useSse must be used within a SseContextProvider');
  }
  return context;
}

